export const version = "hash/5.5.0";
//# sourceMappingURL=_version.js.map